import { IEntity } from "../../../domain/entity";

export class EntityFilterParameter {
  constructor(source: IEntity<string>[] = null) {
    this.entities = source;
  }

  private _entities: IEntity<string>[];

  public get entities(): IEntity<string>[] {
    return this._entities;
  }

  public set entities(source: IEntity<string>[]) {
    this._entities = source;
    this._dictionary = this._entities
      ? this.toDictionary(source)
      : null;
  }

  private toDictionary(source: IEntity<string>[]): { [key: string]: IEntity<string>; } {
    const results: { [key: string]: IEntity<string>; } = {};
    if (this._entities) {
      for (const e of this._entities) {
        results[e.id] = e;
      }
    }
    return results;
  }

  private _dictionary: { [key: string]: IEntity<string>; };

  filter(source: IEntity<string>): boolean {
    return !this._dictionary
        || (source && !!this._dictionary[source.id]);
  }

  // _dictionaryにないものを表示
  filterNotContains(source: IEntity<string>): boolean {
    return !this._dictionary
        || (source && !this._dictionary[source.id]);
  }

  clone(): EntityFilterParameter {
    return new EntityFilterParameter(this.entities);
  }
}
